import { IFluidCodeDetails, IFluidPackage } from '@fluidframework/core-interfaces';
import { CodeDetailsResolver } from './CodeDetailsResolver';
import { safeLocalStorage } from '@fluidx/utilities';

const STREAM_CODE_DETAILS_STORAGE_ENTRY = '_Fluid_Office_Stream_CodeDetailsPackage_';

const streamOriginRegex = /^https?:\/\/.*(\.microsoftstream\.com|\.stream\.azure-test\.net)$/i;
const videoIdExtractRegEx = /video\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i;

function getCodeDetailsPackageStorageOverride() {
  return safeLocalStorage()?.getItem(STREAM_CODE_DETAILS_STORAGE_ENTRY);
}

function getCodeDetails(videoId: string, videoURL: string): IFluidCodeDetails | undefined {
  const codeDetailsPackageOverride = getCodeDetailsPackageStorageOverride();
  if (codeDetailsPackageOverride) {
    try {
      const packageContent = JSON.parse(codeDetailsPackageOverride) as IFluidPackage;
      return {
        config: {
          videoId,
          videoURL
        },
        package: packageContent
      };
    } catch (e: any) {
      // parsing went wrong, the override is not valid.
      return undefined;
    }
  }

  return undefined;

  // The final code should look like below.
  // This has been disabled by default to prevent any unwilling side-effects on
  // OWA during the development.
  // return {
  //   config: {
  //     videoId
  //   },
  //   package: {
  //     name: "@msstream/experiences-fluid-embed",
  //     version: "0.1.3",
  //     fluid: {
  //       browser: {
  //         umd: {
  //           files: [
  //             "https://amsglob0cdnstream13.azureedge.net/streamContainer.js"
  //           ],
  //           library: "StreamContainer"
  //         }
  //       }
  //     }
  //   }
  // };
}

export const StreamCodeDetailsResolver: CodeDetailsResolver = {
  resolve(url: URL): Promise<IFluidCodeDetails | undefined> {
    const { href, origin } = url;

    // Is it Stream ?
    if (!streamOriginRegex.test(origin)) {
      return Promise.resolve(undefined);
    }

    // If it is, try extract Video ID
    const matches = href.match(videoIdExtractRegEx);
    if (matches && matches.length > 1) {
      return Promise.resolve(getCodeDetails(matches[1], href));
    }

    // No match if anything goes wrong
    return Promise.resolve(undefined);
  }
};
